import React from 'react'
import { Search } from 'lucide-react'

import { Input } from '@/components/ui/input'

interface CompanySearchProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const CompanySearch: React.FC<CompanySearchProps> = ({
  value,
  onChange,
  placeholder = 'Search',
}) => {
  return (
    <div className="relative w-full">
      <Search className="absolute w-4 h-4 -translate-y-1/2 left-3 top-1/2 text-gray-light-500" />
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-10"
      />
    </div>
  )
}
